export const TEMPLATE_CONSTANTS = {
  DROPDOWN: {
    MAX_NAVIGATION_DEPTH: 2,
  },
};
